export const en = {
  // Navigation
  nav: {
    home: 'Home',
    traveler: 'Traveler Experience',
    partner: 'Partner Success',
    vienna: 'Vienna Discovery',
    host: 'Host Program',
    signup: 'Partner Signup',
  },
  
  // Common UI Elements
  common: {
    cta: {
      signupNow: 'Sign Up Now',
      becomePartner: 'Become a Partner',
      downloadApp: 'Download App',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      contactUs: 'Contact Us',
      applyNow: 'Apply Now',
      exploreVienna: 'Explore Vienna',
      startExploring: 'Start Exploring',
      viewDashboard: 'View Dashboard',
      readMore: 'Read More',
    },
    loading: 'Loading...',
    loadingText: 'Loading {page}...',
    error: 'An error occurred',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort by',
    noResults: 'No results found',
    trustedBy: 'Trusted by {value}+ {entity}',
    freeUntil: 'FREE',
    untilEndOfYear: 'Until End of Year',
  },
  
  // Metadata/SEO
  metadata: {
    home: {
      title: 'TravelHeroes - Discover Vienna with Local Heroes',
      description: 'Exclusive experiences and authentic savings in Vienna. Connect with local experts and experience Vienna like a local.',
    },
    partnerSuccess: {
      title: 'Partner Success Center - TravelHeroes',
      description: 'Join Vienna\'s leading tourism platform. Attract quality tourists, increase revenue, and grow your business with zero upfront costs. Comprehensive business case with ROI calculators, dashboard previews, and growth testimonials.',
    },
    partnerSignup: {
      title: 'Partner Signup - TravelHeroes',
      description: 'Sign up now and become a TravelHeroes partner. Reach thousands of tourists in Vienna and boost your revenue.',
    },
    travelers: {
      title: 'Traveler Experience - TravelHeroes',
      description: 'Your journey, your way. Discover authentic experiences in Vienna, curated by local experts.',
    },
    vienna: {
      title: 'Discover Vienna - TravelHeroes',
      description: 'Explore the heart of Europe. From imperial palaces to modern art scenes - Vienna awaits you with unforgettable experiences.',
    },
    hosts: {
      title: 'Host Program - TravelHeroes',
      description: 'Become a local hero. Share your city with travelers and earn money while showing tourists your favorite spots.',
    },
  },
  
  // Homepage
  home: {
    hero: {
      headline: 'Discover Vienna Like a Local Hero',
      subtitle: 'Exclusive experiences, authentic savings, unforgettable memories',
      travelerTab: 'Traveler',
      partnerTab: 'Partner',
      travelerTitle: 'Discover Vienna Like a Local Hero',
      travelerSubtitle: 'Exclusive experiences, authentic savings, unforgettable memories',
      partnerTitle: 'Attract More Tourists to Your Business',
      partnerSubtitle: 'Cost-effective marketing with measurable ROI and real results',
    },
    stats: {
      tourists: '{value}+ Tourists/Year',
      touristsAnnual: '{value}+ Annual Tourists',
      rooms: '{value}+ Hotel Rooms',
      roomsApartments: '{value}+ Hotel Rooms & Apartments',
      nights: '{value}+ Nights',
      nightsSpent: '{value}+ Nights Spent in Vienna',
      travelers: '{value}+ Happy Travelers',
      partners: '{value}+ Partners',
      offers: '{value}+ Offers',
      rating: '{value} Average Rating',
      ratingText: 'Rated excellent by {value}+ users',
    },
    features: {
      title: 'Why Choose TravelHeroes',
      subtitle: 'Experience travel reimagined',
      items: [
        {
          title: 'Local Expertise',
          description: 'Connect with local experts who know their city inside and out',
        },
        {
          title: 'Exclusive Offers',
          description: 'Access special discounts and deals available only to our community',
        },
        {
          title: 'Authentic Experiences',
          description: 'Discover hidden gems and experience destinations like a local',
        },
      ],
    },
    testimonials: {
      title: 'What Our Travelers Say',
      subtitle: 'Real stories from real adventurers',
    },
    cta: {
      title: 'Ready to Start Your Adventure?',
      subtitle: 'Join thousands of travelers discovering authentic experiences',
    },
  },
  
  // Partner Success Center
  partnerSuccess: {
    hero: {
      headline: 'Transform Tourists Into Your Best Customers',
      subtitle: 'Grow your business with TravelHeroes',
      description: 'Join Vienna\'s leading platform connecting local businesses with experience-seeking travelers. Increase foot traffic, boost revenue, and build lasting customer relationships.',
      trustedBy: 'Trusted by {value}+ Vienna Businesses',
      badgeText: 'Trusted by {value}+ Vienna Businesses',
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Your business, your rules – complete flexibility in how you engage with travelers',
      requirementTitle: 'Partners Must Offer Value to Travelers',
      requirementDescription: 'To join TravelHeroes, partners are required to offer some form of benefit or discount to our travelers. This could be:',
      options: [
        {
          title: 'Percentage Discount',
          example: '10% off total bill'
        },
        {
          title: 'Fixed Amount Off',
          example: '€5 off purchase'
        },
        {
          title: 'Free Goodie',
          example: 'Complimentary dessert or drink'
        },
        {
          title: 'Your Creative Idea',
          example: 'Any benefit you can think of!'
        }
      ],
      flexibilityTitle: 'Complete Flexibility – You Decide',
      flexibilityDescription: 'Unlike other platforms that dictate strict terms and conditions, TravelHeroes gives you complete control. You choose what works best for your business and your customers. We don\'t tell you what to do – we simply connect you with travelers looking for authentic Vienna experiences.',
      footerText: 'Your creativity = Your success.',
      footerHighlight: 'Design an offer that makes sense for your business while delighting travelers.'
    },
    benefits: {
      title: 'Why Vienna Businesses Choose TravelHeroes',
      subtitle: 'Everything you need to attract and convert tourist traffic into loyal customers',
      items: [
        {
          title: 'NO COST Until December 31, 2026',
          description: 'Join now with absolutely zero fees, no setup costs, and no commissions until end of 2026. Start growing your business risk-free.',
          highlight: 'Zero financial commitment through December 31, 2026'
        },
        {
          title: 'Quality Tourist Traffic',
          description: 'Connect with engaged travelers actively seeking authentic Vienna experiences. Our platform brings pre-qualified tourists directly to your business.',
          highlight: 'Reach experience-seeking travelers, not bargain hunters'
        },
        {
          title: 'Real-Time Analytics Dashboard',
          description: 'Track your performance with comprehensive analytics. Monitor bookings, revenue, and customer engagement all in one powerful dashboard.',
          highlight: 'Make data-driven decisions to optimize your offers'
        },
        {
          title: 'Complete Flexibility',
          description: 'Full control over your offers, availability, and pricing. Update your listings instantly and manage everything on your schedule.',
          highlight: 'Update offers in real-time from any device'
        },
        {
          title: 'Mobile-First Platform',
          description: 'Reach tourists where they are with our highly-rated mobile app that travelers use throughout their Vienna journey.',
          highlight: 'Professional exposure without marketing hassle'
        },
        {
          title: 'Built-in Verification',
          description: 'Secure QR code validation system ensures only legitimate redemptions. Protect your business from coupon abuse.',
          highlight: 'Fraud protection and secure transactions'
        }
      ],
      tourismTitle: 'Tap Into Vienna\'s Tourism Market',
      tourismSubtitle: 'Join the platform connecting businesses with Vienna\'s thriving tourism ecosystem',
      tourismStats: {
        tourists: '400,000+',
        touristsLabel: 'Individual Tourists Per Year',
        rooms: '600+',
        roomsLabel: 'Hotel Rooms & Apartments',
        nights: '900,000+',
        nightsLabel: 'Nights Spent in Vienna'
      }
    },
    comparison: {
      badge: 'Side-by-Side Comparison',
      title: 'TravelHeroes vs. Traditional Marketing',
      subtitle: 'See why smart Vienna businesses are making the switch',
      tableHeaders: {
        feature: 'Feature',
        traditional: 'Traditional Platforms',
        travelheroes: 'TravelHeroes'
      },
      items: [
        {
          feature: 'Setup Cost',
          traditional: '€500-2,000',
          travelheroes: '€0'
        },
        {
          feature: 'Monthly Fee',
          traditional: '€50-200',
          travelheroes: '€0 (until end of 2024)'
        },
        {
          feature: 'Commission Rate',
          traditional: '20-30%',
          travelheroes: '0% (until end of 2024)'
        },
        {
          feature: 'Target Audience',
          traditional: 'Generic tourists',
          travelheroes: 'Experience seekers'
        },
        {
          feature: 'Analytics Dashboard',
          traditional: 'Basic reports',
          travelheroes: 'Real-time insights'
        },
        {
          feature: 'Offer Flexibility',
          traditional: 'Limited changes',
          travelheroes: 'Unlimited updates'
        },
        {
          feature: 'Customer Quality',
          traditional: 'Price-focused',
          travelheroes: 'Value-focused'
        },
        {
          feature: 'Support',
          traditional: 'Email only',
          travelheroes: 'Dedicated manager'
        }
      ],
      advantageTitle: 'The TravelHeroes Advantage',
      advantageDescription: 'Save on marketing costs while reaching higher-quality tourists who value authentic experiences. No contracts, no commitments - just results. Launch risk-free with zero costs until end of year.',
      ctaButton: 'Sign Up Now',
      ctaFooter: 'No credit card required • Cancel anytime • Full support included'
    },
    faq: {
      badge: 'Partner Support',
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about becoming a TravelHeroes partner',
      items: [
        {
          category: 'Pricing',
          question: 'What are the costs to join TravelHeroes?',
          answer: 'There are zero upfront costs or monthly fees. We only charge a 15% commission on completed transactions when tourists redeem your offers. You only pay when you get results.'
        },
        {
          category: 'Pricing',
          question: 'How does the commission structure work?',
          answer: 'Our 15% commission is automatically deducted from each transaction. For example, if a tourist redeems a €20 offer, you receive €17. All payments are processed weekly via bank transfer.'
        },
        {
          category: 'Getting Started',
          question: 'How long does the approval process take?',
          answer: 'Most applications are reviewed within 24-48 hours. Once approved, you can set up your profile and create offers immediately. Your business can be live on the platform within 3 days.'
        },
        {
          category: 'Getting Started',
          question: 'What types of businesses can join?',
          answer: 'We welcome restaurants, cafés, attractions, museums, retail shops, tour operators, and any Vienna business that offers experiences or services tourists would enjoy. Each application is reviewed individually.'
        },
        {
          category: 'Operations',
          question: 'How do tourists redeem offers?',
          answer: 'Tourists show a unique QR code from the TravelHeroes app at your location. You scan it with our partner app or web dashboard to verify and complete the redemption. The process takes less than 10 seconds.'
        },
        {
          category: 'Operations',
          question: 'Can I modify or pause my offers?',
          answer: 'Yes, you have complete control. Update offer details, adjust availability, or pause offers anytime through your dashboard. Changes take effect immediately without any approval delays.'
        },
        {
          category: 'Support',
          question: 'What kind of support do partners receive?',
          answer: 'Every partner gets a dedicated account manager, 24/7 technical support, marketing materials, and access to our partner community forum. We also provide monthly webinars on tourism trends and optimization strategies.'
        },
        {
          category: 'Support',
          question: 'Is there a contract or minimum commitment?',
          answer: 'No contracts or long-term commitments required. You can pause or cancel your partnership anytime with no penalties. We believe in earning your business through results, not binding agreements.'
        }
      ],
      stillQuestionsTitle: 'Still Have Questions?',
      stillQuestionsDescription: 'Our partner success team is here to help. Write us an email to discuss how TravelHeroes can work for your specific business needs.',
      consultationButton: 'Schedule Consultation',
      emailButton: 'Email Support'
    },
    cta: {
      title: 'Ready to Grow Your Business?',
      subtitle: 'Join Vienna\'s leading tourism platform and start attracting quality tourists today.',
      button: 'Sign Up Now'
    },
    sections: {
      benefits: 'Benefits',
      roi: 'ROI Calculator',
      dashboard: 'Dashboard Preview',
      comparison: 'Market Comparison',
      stories: 'Success Stories',
    },
  },
  
  // Partner Signup
  partnerSignup: {
    hero: {
      headline: 'Become a TravelHeroes Partner',
      subtitle: 'Reach thousands of tourists and boost your revenue',
    },
    form: {
      title: 'Partner Registration Form',
      description: 'Fill out the form and we\'ll get in touch with you',
      businessName: 'Business Name',
      contactPerson: 'Contact Person',
      email: 'Email',
      phone: 'Phone',
      businessType: 'Business Type',
      message: 'Message (optional)',
      submit: 'Become a Partner',
      embedUrl: 'https://docs.google.com/forms/d/e/YOUR_ENGLISH_FORM_ID/viewform?embedded=true',
    },
  },
  
  // Traveler Experience
  travelers: {
    hero: {
      headline: 'Your Journey, Your Way',
      subtitle: 'Authentic experiences curated by locals',
    },
    features: {
      title: 'App Features',
      subtitle: 'Everything you need for the perfect trip',
      items: [
        {
          title: 'Exclusive Deals',
          description: 'Save up to 40% on attractions, restaurants, and hotels',
        },
        {
          title: 'Live Availability',
          description: 'Real-time updates on offers and available spots',
        },
        {
          title: 'Insider Tips',
          description: 'Discover hidden gems from real Viennese locals',
        },
      ],
    },
    offers: {
      title: 'Live Offers',
      subtitle: 'Exclusive deals just for you',
      upTo: 'Up to',
      discount: '{value}% Off',
    },
    testimonials: {
      title: 'Traveler Stories',
      subtitle: 'Hear from our community',
    },
    download: {
      title: 'Download the App',
      subtitle: 'Start your adventure today',
      description: 'Available on iOS and Android',
    },
  },
  
  // Vienna Discovery
  vienna: {
    hero: {
      headline: 'Discover Vienna',
      subtitle: 'Explore the heart of Europe',
      description: 'From imperial palaces to modern art scenes - Vienna awaits you',
    },
    stats: {
      title: 'Vienna at a Glance',
      population: '{value}M Population',
      districts: '{value} Districts',
      palaces: '{value}+ Palaces',
      coffeehouses: '{value}+ Coffeehouses',
    },
    districts: {
      title: 'Explore Districts',
      subtitle: 'Each with unique character',
    },
    hiddenGems: {
      title: 'Hidden Gems',
      subtitle: 'Places locals love',
    },
    experiences: {
      title: 'Viennese Experiences',
      subtitle: 'Unforgettable moments',
    },
    quiz: {
      title: 'Vienna Discovery Quiz',
      subtitle: 'Test your knowledge about the city',
      start: 'Start Quiz',
    },
    cultural: {
      title: 'Cultural Timeline',
      subtitle: 'From imperial times to today',
    },
  },
  
  // Host Program
  hosts: {
    hero: {
      headline: 'Become a Local Hero',
      subtitle: 'Share your city with travelers',
      description: 'Earn money while showing tourists your favorite spots',
    },
    types: {
      title: 'Types of Hosts',
      subtitle: 'Find your role',
      items: [
        {
          title: 'Experience Host',
          description: 'Lead unique tours and activities',
        },
        {
          title: 'Culture Ambassador',
          description: 'Share Vienna\'s history and traditions',
        },
        {
          title: 'Culinary Expert',
          description: 'Show the best food spots in the city',
        },
      ],
    },
    benefits: {
      title: 'Host Benefits',
      subtitle: 'Why become a host',
      items: [
        {
          title: 'Flexible Hours',
          description: 'Work when and how often you want',
        },
        {
          title: 'Fair Compensation',
          description: 'Earn {value}-{max}€ per tour',
        },
        {
          title: 'Free Training',
          description: 'We prepare you optimally',
        },
      ],
    },
    howItWorks: {
      title: 'How to Get Started',
      subtitle: 'Simple onboarding in 4 steps',
      steps: [
        {
          title: 'Application',
          description: 'Fill out the short application form',
        },
        {
          title: 'Training',
          description: 'Participate in our free training',
        },
        {
          title: 'Create Profile',
          description: 'Design your host profile',
        },
        {
          title: 'Get Started',
          description: 'Welcome your first guests',
        },
      ],
    },
    community: {
      title: 'Join Our Community',
      subtitle: 'Connect with other hosts',
      members: '{value}+ active hosts',
    },
    faq: {
      title: 'Host FAQs',
      subtitle: 'Common questions answered',
      items: [
        {
          question: 'Do I need prior experience?',
          answer: 'No! We train you in everything you need to know. You just need passion for Vienna.',
        },
        {
          question: 'How much can I earn?',
          answer: 'Average {value}-{max}€ per tour, depending on duration and group size.',
        },
        {
          question: 'How flexible is hosting?',
          answer: 'Completely flexible! You determine when and how often you are available.',
        },
      ],
    },
    resources: {
      title: 'Host Resources',
      subtitle: 'Everything you need',
    },
    application: {
      title: 'Apply Now',
      subtitle: 'Start your journey as a local hero',
    },
  },
  
  // Footer
  footer: {
    about: 'About Us',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    imprint: 'Imprint',
    accountDeletion: 'Delete Account',
    copyright: '© {year} TravelHeroes. All rights reserved.',
    description: 'Connecting tourists with local heroes in Vienna',
    quickLinks: 'Quick Links',
    legal: 'Legal',
  },

  // Account Deletion
  accountDeletion: {
    hero: {
      title: 'Account Deletion Request',
      description: 'Request deletion of your TravelHeroes account and associated data in compliance with GDPR and Austrian data protection laws.',
    },
    steps: {
      title: 'How to Delete Your Account',
      items: [
        {
          step: 'Submit Request',
          description: 'Enter your email address below to initiate the account deletion process.',
        },
        {
          step: 'Email Verification',
          description: 'You will receive an email with a confirmation link to verify your identity.',
        },
        {
          step: 'Grace Period',
          description: 'Your account will be deactivated immediately. You have 30 days to cancel the deletion if you change your mind.',
        },
        {
          step: 'Permanent Deletion',
          description: 'After 30 days, your account and personal data will be permanently deleted from our systems.',
        },
      ],
    },
    dataInfo: {
      title: 'What Data Will Be Deleted',
      deleted: {
        title: 'The following data will be permanently deleted:',
        items: [
          'Personal information (name, email, phone number)',
          'Account credentials and login information',
          'Booking history and travel preferences',
          'Saved offers and favorites',
          'App usage data and preferences',
        ],
      },
      retained: {
        title: 'Data Retention for Legal Compliance:',
        description: 'In accordance with Austrian law, certain financial and transaction records must be retained:',
        items: [
          'Financial transaction records (retained for 7 years as required by Austrian tax law)',
          'Invoice and payment documentation (retained for 7 years)',
          'Anonymized analytics data for platform improvement',
        ],
      },
      gracePeriod: 'Grace Period: You have 30 days to cancel the deletion request. After this period, deletion is permanent and irreversible.',
    },
    form: {
      title: 'Submit Deletion Request',
      emailLabel: 'Your Email Address',
      emailPlaceholder: 'Enter your account email',
      emailHelp: 'Enter the email address associated with your TravelHeroes account.',
      error: 'Please enter a valid email address.',
      submit: 'Request Account Deletion',
      terms: 'By submitting this request, you acknowledge that your account and personal data will be permanently deleted after the 30-day grace period.',
    },
    success: {
      title: 'Request Submitted Successfully',
      description: 'We have sent a verification email to your address. Please check your inbox and click the confirmation link to proceed with account deletion.',
      newRequest: 'Submit Another Request',
    },
    contact: {
      title: 'Questions About Data Deletion?',
      description: 'For questions about your data or the deletion process, contact our data protection team:',
    },
  },

  // Contact Us
  contact: {
    hero: {
      title: 'Contact Us',
      description: 'Get in touch with our team. We\'re here to help with any questions or support needs.',
    },
    users: {
      title: 'For Travelers & Users',
      description: 'Have questions about using TravelHeroes? Need help with your account or bookings?',
      emailLabel: 'Support Email',
      email: 'support@travelheroes.at',
      linksTitle: 'Helpful Resources',
      links: [
        { label: 'Terms of Service', href: '/terms-of-service' },
        { label: 'Privacy Policy', href: '/privacy-policy' },
        { label: 'Delete Account', href: '/account-deletion' },
      ],
    },
    partners: {
      title: 'For Business Partners',
      description: 'Interested in partnering with TravelHeroes? Have questions about our platform?',
      emailLabel: 'Partner Email',
      email: 'partner@travelheroes.at',
      ctaText: 'Have more questions about becoming a partner?',
      ctaButton: 'Visit Partner FAQ',
      faqLink: '/partner-success-center#faq',
    },
  },
} as const;

export type TranslationKey = typeof en;